import { Button, Cascader, Select, Tooltip } from 'antd'
import CustomSpin from '../../elements/CustomSpin'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

const Option = Select.Option

function CustomCascader (props) {
  const {
    value,
    display,
    onChange,
    placeholder,
    data,
    keyAtr,
    valueAtr,
    fetch,
    fetching,
    ref,
    setSelected,
    setData,
    mode,
  } = props

  useEffect(() => {
    if (!isEmpty(value) && !!setSelected) {
      const item = data.find(a => a[keyAtr] === value)
      setSelected(item)
    }
  }, [value, data && data.length])

  useEffect(() => {
    if (!isEmpty(data) && !!setData) {
      setData(data)
    }
  }, [fetch])

  return (
    <Tooltip
      placement="top"
      mouseEnterDelay={1}
      mouseLeaveDelay={0.5}
      overlayStyle={{ background: 'white' }}
      title={
        <Button
          size={props.size}
          style={{ backgroundColor: 'Transparent', color: 'white' }}
          icon="retweet"
          onClick={fetch}>
          Refresh dropdown
        </Button>
      }
      trigger="hover">
      <CustomSpin spinning={fetching}>
        <Cascader
          data-testid={props['data-testid']}
          style={{ width: '100%' }}
          options={data}
          value={value}
          display={display}
          showSearch
          ref={ref}
          allowClear={true}
          onChange={onChange}
          placeholder={placeholder || 'Select an option'}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          {...props}
        />
      </CustomSpin>
      {/*  {props.children ||*/}
      {/*    data.map(c => (*/}
      {/*      <Option*/}
      {/*        data-testid={get(c, keyAtr)}*/}
      {/*        key={`${get(c, keyAtr)}-${Math.floor(Math.random() * 100000000000000)}`}*/}
      {/*        value={get(c, keyAtr)}*/}
      {/*        title={get(c, valueAtr)}>*/}
      {/*        {mode === 'multiple' ? (*/}
      {/*          <>*/}
      {/*            /!*<Tag color={get(c, 'color', '#2db7f5')}>*!/*/}
      {/*            {get(c, valueAtr) || get(c, keyAtr)}*/}
      {/*            /!*</Tag>*!/*/}
      {/*          </>*/}
      {/*        ) : (*/}
      {/*          get(c, valueAtr) || get(c, keyAtr)*/}
      {/*        )}*/}
      {/*      </Option>*/}
      {/*    ))}*/}
      {/*</Cascader>*/}
    </Tooltip>
  )
}

CustomCascader.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  data: PropTypes.array.isRequired,
  keyAtr: PropTypes.string,
  valueAtr: PropTypes.string,
}

CustomCascader.defaultProps = {
  keyAtr: 'key',
  // setSelected: () => console.error('Not Implemented'),
  valueAtr: 'value',
  data: [],
}
export default CustomCascader
